enum FlexOnboardingEligibilityCode {
  FLXELGBL30200 = 'FLXELGBL30200',
  FLXELGBL30201 = 'FLXELGBL30201',
  FLXELGBL30202 = 'FLXELGBL30202',
  FLXELGBL30203 = 'FLXELGBL30203',
  FLXELGBL30204 = 'FLXELGBL30204',
  FLXELGBL30205 = 'FLXELGBL30205',
}

export default FlexOnboardingEligibilityCode;
